import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  root: {
    paddingRight: 7,
  },
  pdfLink: {
    paddingBottom: 10,
  },
  separator: {
    paddingVertical: 10,
  },
  desc: {
    paddingTop: 10
  }
});
